<template>
  <section class="admin-info">
    <div class="columns super-admin">
      <div class="card">
        <header class="card-header">
          <h6 class="card-header-title is-primary-border has-text-weight-bold">
            {{ organization.name }}
          </h6>
        </header>
        <div class="card-content">
          <div class="content">
            <span v-if="organization.phone">{{ organization.phone }}</span>
            <span v-if="organization.address">{{ organization.address }}</span>
            <span v-if="organization.from_name">{{ organization.from_name }}</span>
            <span v-if="organization.email">{{ organization.email }}</span>
          </div>
        </div>
        <footer class="card-footer">
          <button
            class="button is-white is-info is-outlined is-borderless"
            @click="handleEdit(organization)"
          >
            Edit
          </button>
        </footer>
      </div>
    </div>
  </section>
</template>
<script>
import { Roles, Routes } from '../../constants';
import UserService from '../../services/user.service';

const userService = new UserService();

export default {
  name: 'AdminInfo',
  data() {
    return {
      role: this.$store.state.user.role,
      roles: Roles,
      organization: {},
      selectedOrganizationUuid: null,
      admins: []
    };
  },
  mounted() {
    const { state } = this.$store;
    // eslint-disable-next-line no-use-before-define, no-nested-ternary
    const organization = state.selectedOrganization && Object.keys(state.selectedOrganization).length ? state.selectedOrganization : state.organization && Object.keys(state.organization).length ? organization : {};
    this.selectedOrganizationUuid = organization && Object.keys(organization).length ? organization.uuid : '';
    this.organization = organization;
    this.getAdminList();
  },
  methods: {
    getAdminList() {
      const self = this;

      userService.getAdminList(this.selectedOrganizationUuid)
        .then((response) => {
          const { status, result, message } = response.data;

          if (status === 'success') {
            self.admins = result;
          } else {
            self.$root.$emit('showToast', { message: message || 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
        });
    },
    handleEdit(organization) {
      this.$store.commit('setOrganizationToEdit', { result: organization });
      this.$router.push({ name: Routes.COMPANIES.name });
    },
    getAdminName(admin) {
      return [admin.firstname, admin.lastname].filter((it) => it).join(' ');
    }
  }
};
</script>
<style scoped lang="scss">
    .admin-info {
        .is-borderless {
            border: 0;
        }

        .columns {
            display: flex;
            flex-direction: column;
        }

        .super-admin,
        .admins {
            .column {
                padding-top: 0;
            }
        }

        .card {
            height: 100%;
            display: flex;
            flex-direction: column;

            .card-content {
                height: 100%;
                padding-top: 1rem;
                padding-bottom: 2.5rem;
                line-height: 2rem;
                border-bottom: 1px solid #ededed;

                @apply
                  border-muted-200
                  dark:border-muted-600;

                &:nth-of-type(1) {
                    border-top: 1px solid #ededed;

                    @apply
                      border-muted-200
                      dark:border-muted-600;
                }

                .content {
                    display: flex;
                    flex-direction: column;
                }
            }

            .card-footer {
                display: block;
                padding: 1rem;
                text-align: right;
                border-top: none;
            }
        }
    }
</style>
